// extracted by mini-css-extract-plugin
module.exports = {"prizes":"styles_prizes__1jkeJ","backgroundImage":"styles_backgroundImage__1VFel","prizeList":"styles_prizeList__2bvTe","prize":"styles_prize__3eVvk"};